<div *ngIf="!mostrarFormulario" class="row animated fadeInRight">
  <!-- *FORMULARIO GUARDAR ROL  -->
  <app-lfsa-card-v2 *ngIf="!mostrarGridLista" [innTemplateButton]="innTemplateButton"
                    [innTemplate]="enviarTemplateEdit" [modulo]="DAT_TITULOS.modulo" [tituloCard]="titulo"
                    [titulo]="DAT_TITULOS.titulo">
  </app-lfsa-card-v2>
  <ng-template #innTemplateButton>
  </ng-template>
  <ng-template #enviarTemplateEdit>
    <form [formGroup]="formulario" class="form-group" novalidate>
      <app-selector-pedido-venta-autoconsumo
        [solicitudData]="solicitudData"></app-selector-pedido-venta-autoconsumo>
      <!--      <app-lfsa-botones-formulario (devolverAccion)="acciones( $event )" [formularioValido]="formulario.invalid"
                                         [loading]="loading" [textBoton]="textBoton">
            </app-lfsa-botones-formulario>-->
    </form>
  </ng-template>
  <!--   *GRID LISTAR ROL-->
  <app-lfsa-card-v2 *ngIf="mostrarGridLista" [innTemplateButton]="innTemplateButtonAddRol"
                    [innTemplate]="enviarTemplate" [modulo]="DAT_TITULOS.modulo" [tituloCard]="titulo"
                    [titulo]="DAT_TITULOS.titulo">
  </app-lfsa-card-v2>
  <ng-template #innTemplateButtonAddRol>
    <div class="col-md-6">
      <div class="pagetitle">
        <!--<div class="btn-group-justified btn-group" style="float: right;">
          <a (click)="nuevo()" class="btn btn-outline-success">
            <i aria-hidden="true" class="fa fa-plus"></i>
            {{DAT_BTNS.agregarSolicitudPedido}}
          </a>
        </div>-->
      </div>
    </div>
  </ng-template>
  <ng-template #enviarTemplate>
    <section class="section">
      <form [formGroup]="formularioFiltro" class="form-group" novalidate>
        <div class="row">
          <!--<div class="form-group col-md-6">
            <app-lfsa-combo-box
              (change)="changeOficinaVenta()"
              [comboBox]="cmbOficinaVenta"
              [control]="formularioFiltro.get('idOficinaVenta') | formControl"
              [idOpcion]="'id'" [id]="'idOficinaVenta'" [label]="'Oficina de Venta'"
              [opcion]="'descripcion'"
              formControlName="idOficinaVenta">
            </app-lfsa-combo-box>
          </div>-->
        </div>
      </form>
      <div class="row">
        <div class="col-md-12 ">
          <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
          <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" [columnDefs]="columnDefs"
                           [floatingFilter]="true" [frameworkComponents]="frameworkComponents"
                           [ngStyle]="diccionarioModulo.agGrid.style"
                           [paginationPageSize]="diccionarioModulo.agGrid.paginacion"
                           [pagination]="true" [rowData]="rowData"
                           [rowSelection]="rowSelection" class="{{diccionarioModulo.agGrid.class}}"
                           id="{{diccionarioModulo.agGrid.id}}">
          </ag-grid-angular>
        </div>
        <div class="col-md-6">
          Lista de Gerencias Asigandas:
          <span *ngFor="let gerencia of selectedGerencias" class="badge text-bg-secondary d-inline me-2">
            {{gerencia}}
          </span>
        </div>
      </div>
    </section>
  </ng-template>
</div>


<!--
<ng-container>
  <app-cliente-modal (onSelect)="clienteSelected($event)" [dataReference]="'autoconsumo-cliente'"></app-cliente-modal>
</ng-container>
-->


<ng-container>
  <app-material-modal (onSelect)="materialSelected($event)"></app-material-modal>
</ng-container>
